import { Button, ButtonProps } from "@chakra-ui/react";
import { omit } from "lodash/fp";
import { ReactNode } from "react";

import { colors } from "src/colors";
import { TEXT_STYLES, textStylesType } from "src/typography";
import { toTitleCase } from "src/utils";

type Props = ButtonProps & {
  label?: string;
  textStyle?: textStylesType;
  children?: ReactNode;
};

export const LinkButton = ({ label, textStyle, children, ...props }: Props) => {
  const styles = textStyle ? TEXT_STYLES[textStyle] : TEXT_STYLES.button1;

  return (
    <Button
      bg="transparent"
      fontWeight={500}
      textDecor="underline"
      textUnderlineOffset={4}
      color={colors.orange[400]}
      display="inline-block"
      cursor="pointer"
      w="max-content"
      h="max-content"
      p="0px"
      fontFamily="graphik"
      _hover={{
        color: colors.orange[200]
      }}
      _active={{
        color: colors.black[900]
      }}
      _disabled={{
        color: colors.grey[400],
        cursor: "auto",
        _hover: {
          color: colors.grey[400]
        }
      }}
      {...(omit(["as"], styles) as {
        fontSize: string[];
        lineHeight: string;
        letterSpacing: string;
        fontWeight: number;
      })}
      {...props}
    >
      {children || toTitleCase(label)}
    </Button>
  );
};
